import { merge } from "@visactor/vutils";

import { LabelBase } from "./base";

import { labelingPoint } from "./util";

export class SymbolLabel extends LabelBase {
    constructor(attributes, options) {
        super((null == options ? void 0 : options.skipDefault) ? attributes : merge({}, SymbolLabel.defaultAttributes, attributes)), 
        this.name = "symbol-label";
    }
    labeling(textBounds, graphicBounds, position = "top", offset = 0) {
        return labelingPoint(textBounds, graphicBounds, position, offset);
    }
}

SymbolLabel.defaultAttributes = {
    textStyle: {
        fill: "#000"
    },
    position: "top",
    offset: 5
};
//# sourceMappingURL=symbol.js.map
